
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profiles",
      function () {
        return require("private-next-pages/profiles/index.tsx");
      }
    ]);
  